import { Theme, useMediaQuery } from "@mui/material";
import { mobileBreakPoint } from "constants/responsiveness";

export const useMobile = (): boolean => {
  return useMediaQuery<Theme>((t) => t.breakpoints.down(mobileBreakPoint));
};
